/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Logs} from "../../APIClient.jsx";
import ChartBase from "../Charts/ChartBase.jsx";
import {Util} from "../../Utilities.js";
import Kpi from "../Charts/KPI.jsx";
import DisplayStateHistory from "../DisplayStateHistory.jsx";

class ContainerCharts extends Component {
    constructor() {
        super();

        this.state = {
            timeline: []
        }
    }

    async fetchData() {
        let {nodeId, containerId} = this.props
        let logs = await Logs.getContainerLogs(containerId, `containerStats`)
        let rows = (logs?.logs ?? [])

        let timeline = rows.map(row => {
            let [date, line] = row.log.split("\t")
            return Util.objects.tryParse(line)
        })
        // remove invalid rows
        timeline = timeline.filter(item => (item !== false))
        timeline = timeline.sort((a, b) => (a.timestamp - b.timestamp))

        this.setState({timeline: timeline})

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.containerId !== prevProps.containerId) {
            this.fetchData()
        }
    }

    componentDidMount() {
        this.fetchData()

        this.interval = setInterval(() => {
            this.fetchData()

        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    render() {
        const {timeline} = this.state;
        const {containerId} = this.props;

        const last = timeline.at(-1);

        const cpuP = Math.round(last?.cpuUsage ?? 0);
        const memP = Math.round(last?.memoryPercent ?? 0);
        const txMBs = (last?.networkTxMBs ?? 0).toFixed(1);
        const rxMBs = (last?.networkRxMBs ?? 0).toFixed(1);

        return (
            <div className="space-y-4 divide-stone-200 divide-y ">
                <dl className="grid grid-cols-1 gap-5 sm:grid-cols-4 p-5 pb-8">
                    <Kpi title="CPU Usage" value={cpuP} unit={"%"} className={"text-indigo-500!"}/>
                    <Kpi title="Memory Usage" value={memP} unit={"%"} className={"text-emerald-500!"}/>
                    <Kpi title="TX" value={txMBs} unit={"MB/s"}/>
                    <Kpi title="RX" value={rxMBs} unit={"MB/s"}/>
                </dl>

                {/* ───────── Charts ───────── */}
                <ChartBase
                    titel="CPU Usage"
                    unit="%"
                    max={100}
                    color="rgb(99,102,241)"
                    data={timeline.map(t => ({x: t.timestamp * 1000, y: t.cpuUsage}))}
                />

                <ChartBase
                    titel="Memory Usage %"
                    unit="%"
                    max={100}
                    color="rgb(16,185,129)"
                    data={timeline.map(t => ({x: t.timestamp * 1000, y: t.memoryPercent}))}
                />

                <ChartBase
                    titel="Memory Used (MiB)"
                    unit=" MiB"
                    color="rgb(16,185,129)"
                    data={timeline.map(t => ({x: t.timestamp * 1000, y: t.memoryUsage}))}
                />

                <ChartBase
                    titel="Network TX (MB/s)"
                    unit=" MB/s"
                    color="rgb(239,68,68)"
                    data={timeline.map(t => ({x: t.timestamp * 1000, y: t.networkTxMBs}))}
                />

                <ChartBase
                    titel="Network RX (MB/s)"
                    unit=" MB/s"
                    color="rgb(2,132,199)"
                    data={timeline.map(t => ({x: t.timestamp * 1000, y: t.networkRxMBs}))}
                />
                <div className={"h-70 w-full border rounded-lg p-1 bg-white flex flex-col"}>
                    <div className={"flex items-center w-full h-10 justify-center text-sm"}>State
                        history
                    </div>
                    <DisplayStateHistory name={"Container"} elementId={containerId}/>
                </div>
            </div>
        );
    }
}

ContainerCharts.propTypes = {};

ContainerCharts.defaultProps = {};


export default ContainerCharts;